export enum RerunReportingImportNormalizationRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
}

export interface RerunReportingImportNormalizationRequest {
  [RerunReportingImportNormalizationRequestKeys.runId]?: string | null;
  [RerunReportingImportNormalizationRequestKeys.uploadActionId]?: string | null;
}

export interface RerunReportingImportNormalizationResponse {
  runId: string;
  recordsTotal: number;
  recordsValid: number;
  recordsInvalid: number;
  unresolvedNormalizationIssuesCount: number;
}
